import httpClient from '@/services/http/httpClient'

export const apiPostTrackTMO = params => {
  return httpClient.post('api-token-auth/auditTMO/', params)
}
